// @core/api/endpoints/notifications/get_team_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamSettingsResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get team notification settings
 * Retrieves the notification settings configured for a team. Team settings can define default preferences for all team members.
 */
export async function GetTeamSettings(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/teams/:team_id/settings`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamSettingsResponse>(requestPath, { ...requestOptions });
}
